import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import ICharacteristics, { ICharacteristicItem } from '../../interfaces/ICharachteristics'
import { characteristicsList, characteristicsSave } from '../../services/api'

interface CharacteristicsContextState extends BaseContextState {
  characteristics: ICharacteristics
  characteristicsRaw?: ICharacteristicItem[]
}

export interface CharacteristicsContextData extends CharacteristicsContextState {
  requestCharacteristics: () => Promise<any>
  requestCharacteristicsSave: (args: any) => Promise<any>
}

const { Provider, Consumer } = createContext({} as CharacteristicsContextData)

export const CharacteristicsConsumer = Consumer

export class CharacteristicsProvider extends BaseContextProvider {
  state: CharacteristicsContextState = {
    characteristics: [],
    characteristicsRaw: undefined
  }

  /**
   * Get base characteristics from the api
   */
  requestCharacteristics = async () => {
    this.setState({ fetching: true, error: false }, async () => {
      const response = await characteristicsList({
        search: {
          _fields: ['id', 'uuid', 'name', 'description', 'icon', 'characteristic_group_id', 'key'],
          group: {
            with: {
              _fields: ['id', 'uuid', 'name', 'description']
            }
          }
        },
        options: {
          limit: 'all'
        }
      })

      const built = this.buildCharacteristics(response?.result)

      this.setState({ characteristics: built, characteristicsRaw: response?.result, fetching: false })
    })
  }

  /**
   * Rearrange the characteristics to use the same pattern accross apps
   * @param {Array} input
   * @returns {ICharacteristics} characteristics
   */
  buildCharacteristics(input) {
    if (!input?.length) return []

    const groups = {}

    input.forEach(char => {
      const { group } = char

      if (!groups[group.uuid]) {
        groups[group.uuid] = group
        groups[group.uuid]['characteristics'] = []
      }

      groups[group.uuid]['characteristics'].push(char)
    })

    return Object.values(groups)
  }

  /**
   * Saves characteristics description and translations
   * @param data 
   */
  requestCharacteristicsSave = async (data) => {
    this.setState({ saving: true }, async () => {
      await characteristicsSave(data)
    })
  }

  render() {
    return (
      <Provider
        value={{
          ...this.state,

          requestCharacteristics: this.requestCharacteristics,
          requestCharacteristicsSave: this.requestCharacteristicsSave
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
